import { render, staticRenderFns } from "./ValueSelector.vue?vue&type=template&id=1c561502&scoped=true"
import script from "./ValueSelector.vue?vue&type=script&lang=js"
export * from "./ValueSelector.vue?vue&type=script&lang=js"
import style0 from "./ValueSelector.vue?vue&type=style&index=0&id=1c561502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c561502",
  null
  
)

export default component.exports